// Generic Button Constants
export const BUTTON_CONTINUE = "Continue";
export const BUTTON_CONFIRM = "Confirm";
export const BUTTON_CANCEL = "Cancel";
export const BUTTON_BACK = "Back";

// Left-Nav Constants
export const LEFT_NAV_CREATE_ESTATE_PLAN = "Create estate plan report:";
// This is being kept here because Jacqui wants it as a display feature in future iterations of the page
// export const LEFT_NAV_LAST_VANILLA_SYNC = "Last Vanilla sync on 03/14/24";
export const LEFT_NAV_SYNC_WITH_VANILLA = "Sync data with Vanilla";

export const GUIDED_FLOW_ENTER_TITLING_AND_DETAILS = "Enter titling and details.";

export const OVERVIEW_PAGE_DISCLOSURES = [
  {
    text: "For outside assets you've entered manually, the balances are as of when you added the asset or the last time you updated your account balance in this inventory."
  },
  {
    text: "The total balance shown for your personal trust accounts is the combined total for all accounts held within that trust. If you have any questions or need additional information, please contact your trust advisor."
  },
  {
    text: "Documents and information on this page pertaining to any holdings in Vanguard HarbourVest Funds (“VGHV Funds”) are presented solely for your convenience. The VGHV Funds are held away from The Vanguard Group, Inc., and its affiliates (collectively referred to as “Vanguard”) at HarbourVest Partners, LLC, a registered investment adviser under the Investment Advisers Act of 1940 (“HarbourVest”), or its affiliates."
  },
  {
    text: "Please note that the VGHV Fund information displayed is as of the most recent calendar quarter-end and does not reflect any VGHV Fund investment activity or cash flows occurring after that date, so balances and distribution amounts on this page may be different from what's reported on the HarbourVest website. For questions, contact HarbourVest directly at ",
    link: {
      href: "mailto:clientservice@harbourvest.com",
      text: "clientservice@harbourvest.com"
    }
  },
  {
    text: "Vanguard's advice services are provided by Vanguard National Trust Company (“VNTC”), a federally chartered, limited-purpose trust company."
  }
];

// Save-Status-Modal Constants
export const VANILLA_MODAL_SAVING_DATA = "Saving data...";
export const VANILLA_MODAL_SYNCING_DATA = "Syncing data with Vanilla...";
export const VANILLA_MODAL_SUCCESS_HEADER = "Success! Data has been sent to Vanilla";
export const VANILLA_MODAL_SUCCESS_CONTENT = "Vanilla will open in a new tab shortly.";
export const VANILLA_MODAL_ERROR_HEADER = "Error";
export const VANILLA_MODAL_ERROR_CONTENT = "We are unable to sync data with Vanilla at this time. Please try again later.";
export const VANILLA_MODAL_SYNCING_ATTEMPT = "Currently trying to sync with Vanilla.";
export const VANILLA_MODAL_SYNCING_IN_PROGRESS = "Syncing in progress";
export const GUIDED_FLOW_ADD_ACCOUNT_LOADING_CONTENT = "Please wait, your account is being added.";
export const GUIDED_FLOW_EDIT_ACCOUNT_LOADING_CONTENT = "Please wait, your account information is being updated.";
// This isn't going to be shown on the modal since it currently (6/5/2025) routes back to the personal-wealth-inventory before a user would be able to see this content, so you can have this be any value hehe :^)
export const GUIDED_FLOW_PLACEHOLDER_SUCCESS_CONTENT = "Your account has been successfully added/updated.";
export const GUIDED_FLOW_ADD_ACCOUNT_ERROR_CONTENT = "Your account couldn't be added at this time. Please try again later.";
export const GUIDED_FLOW_EDIT_ACCOUNT_ERROR_CONTENT = "Your account information couldn't be updated at this time. Please try again later.";
export const POLLING_INTERVAL_PERIOD = 1000;
export const POLLING_MAX_ATTEMPTS = 60;
export const VEX_GET_STATUS_COMPLETED = "COMPLETED";
export const VEX_GET_STATUS_PROCESSING = "PROCESSING";
export const VEX_GET_STATUS_ERRORED = "ERRORED";

// Client-Data Constants
export const SAVE_DATA_SUCCESS_CONTENT = "Client data has been saved.";
export const SAVE_DATA_ERROR_CONTENT =
  "Data was not saved successfully. Please try again or come back later.";
export const FAMILY_WEALTH_PLAN = "family wealth plan";
export const PERSONAL_DETAILS_HEADER = "Personal details";
export const VANGUARD_ACCOUNTS_HEADER = "Vanguard accounts";
export const EXTERNAL_ACCOUNTS_HEADER = "External accounts";
export const VANGUARD_ACCOUNTS_CONTENT = "Vanguard accounts in the";
// For the second part after the family name, use FAMILY_WEALTH_PLAN
export const EXTERNAL_ACCOUNTS_CONTENT = "Add any other accounts you want to include in the";
// For the second part after the family name, use FAMILY_WEALTH_PLAN
export const VANGUARD_ACCOUNTS_LABEL = "Vanguard";
export const EXTERNAL_ACCOUNTS_LABEL = "External";
export const NO_YODLEE_ACCOUNTS = "Yodlee accounts are not included in the external accounts table. These accounts must be entered manually in Vanilla."
export const IIP_BUTTON_TEXT = "Add another external account in IIP";
export const IIP_BUTTON_REFRESH = "Refresh";
export const IIP_BUTTON_ICON_LINK_RIGHT = "link-right";
// export const IIP_BUTTON_ICON_REFRESH = "refresh";

// Personal-Info Constants
// PRIMARY_ACCOUNT_NAME & SPOUSE_PARTNER_NAME are pulled into the AccountRole enum and then passed into personal-info through its client-data parent component
export const PRIMARY_ACCOUNT_NAME = "Primary Account Name:";
export const SPOUSE_PARTNER_NAME = "Spouse/partner:";
export const DOB = "DOB:";
export const ADDRESS = "Address:";

// Account Tables Constants
export const TABLE_HEADER_NAME = "Name";
export const TABLE_HEADER_ACCOUNT = "Account";
export const TABLE_HEADER_BALANCE = "Balance";
export const TABLE_HEADER_ACTIONS = "Actions";
export const TABLE_HEADER_INCLUDE_EXCLUDE = "Include/Exclude";
export const TABLE_HEADER_INTERNAL_HEADER = "Sync";
export const PRIMARY = "PRIMARY";
export const SECONDARY = "SECONDARY";
export const JOINT_OWNER = "JOINT_OWNER";
export const INCLUDED = "";
export const EXCLUDED = "";
export const INCLUDE_ALL = "Include all";
export const EXCLUDE_ALL = "Exclude all";
export const EXCLUDE_CONTENT = "By excluding this asset, it won't be included in your Wealth Planning Report, but it will still appear in the list as 'excluded' for reference.";
export const INCLUDE_CONTENT = "Are you sure you want to include this asset back into your wealth planning report?";
export const INCLUDE_HEADER = "Include this asset";
export const EXCLUDE_HEADER = "Are you sure you want to exclude this asset?";
export const INTERNAL_CONTENT = "This asset is currently 'excluded' from the client's personal wealth inventory. Are you sure you want to send it to Vanilla to include it in their Wealth Planning Report?";
export const SHOW_HIDDEN_ON = "Show excluded accounts";
export const SHOW_HIDDEN_OFF = "Show excluded accounts";
export const WARNING_ICON_TOOLTIP_CANNOT_EDIT = "You currently cannot edit or view this type of account at this time";
export const WARNING_ICON_TOOLTIP_MISSING_OWNER = "This account is missing an owner";
export const WARNING_ICON_TOOLTIP_NO_JOINT_OWNER = "Joint owner type is not specified";

// Delete Content Templates - use {{entityType}} placeholder
export const DELETE_LOADING_CONTENT = "Please wait, your {{entityType}} is being deleted.";
export const DELETE_SUCCESS_CONTENT = "Your {{entityType}} has been successfully deleted.";
export const DELETE_ERROR_CONTENT = "Your {{entityType}} couldn't be deleted at this time. Please try again later.";
export const DELETE_CONFIRMATION_CONTENT = "Are you sure you want to remove this {{entityType}} from your personal wealth inventory? (This MEOA will be deleted across all other areas, secure site, etc)";

/**
 * Replaces {{entityType}} placeholder in delete content templates
 * @param template - The template string (e.g., DELETE_LOADING_CONTENT)
 * @param entityType - The type of entity: 'account', 'asset', or 'liability'
 * @returns The rendered message with the entity type
 */
export const getDeleteContent = (template: string, entityType: 'account' | 'asset' | 'liability'): string => {
  return template.replace(/\{\{entityType\}\}/g, entityType);
};

// Delete Constants - Cascade Warning Function
export const DELETE_ASSET_CASCADE_WARNING = (mortgageCount: number): string =>
  `Are you sure you want to remove this asset from your personal wealth inventory? This will also delete ${mortgageCount} linked mortgage${mortgageCount > 1 ? 's' : ''}. (This MEOA will be deleted across all other areas, secure site, etc)`;

// Error-State Constants
export const ERROR_HEADER = "Sorry, something went wrong";
export const ERROR_CONTENT = "We were unable to retrieve your data. Please try again or come back later. We apologize for the inconvenience.";

export const SPOUSE_ERROR_HEADER = "This page is unavailable";
export const SPOUSE_ERROR_CONTENT = "This resource can only be accessed through the Primary Client in the Advice Relationship.";

export const FORBIDDEN_ERROR_CONTENT = "You do not have permission to access this resource.";

// Personal Wealth Inventory Constants
export const GRAPHIC_PATTERN_TITLE = "Personal wealth inventory";
export const EXTERNAL_ACCOUNTS_BANNER_HEADER = "Let's get you started";
export const EXTERNAL_ACCOUNTS_BANNER_MESSAGE = "We've already added your Vanguard accounts. By adding your other accounts and assets to this inventory, you'll help us guide you through your estate planning journey.";
export const INVENTORY_ADD_BUTTON = "Add to inventory";
export const VANILLA_SYNC_BUTTON = "Sync data with Vanilla";
export const VANILLA_SYNC_BUTTON_CONTENT = "By toggling the “Sync” column to the off position, the corresponding assets:";
export const VANILLA_SYNC_BUTTON_CONTENT_ARRAY = [
  "Will not be sent to Vanilla when you select “Sync data with Vanilla”.",
  "Will not be included in the total balance numbers.",
  "Will not be visible in the client’s estate planning inventory.",
  "Will need to be manually removed from Vanilla, if they have already been synced."
];
export const ADVISOR_DEVELOPMENT_CENTER_LINK_TEXT = "Advisor Development Center WPR Resources";
export const ADVISOR_DEVELOPMENT_CENTER_LINK_URL = "https://thevanguardgroup.sharepoint.com/sites/AdvisorDevelopmentCenter/SitePages/Wealth-Planning.aspx";
